module.exports = __webpack_public_path__ + "files/62925f75d5619375ada687909fdd3f12.png";